import { DISCOUNT_CATEGORY_EMPTY } from './constants';

const arrayFields = ['state', 'categoryIds', 'discountCategoryNames'];
const textFields = ['productId', 'search', 'quantityFrom', 'quantityTo', 'priceFrom', 'priceTo', 'discountFrom', 'discountTo'];

export const readProductListQuery = (search) => {
  const params = new URLSearchParams(search);
  const query = {};
  textFields.forEach(key => { query[key] = params.get(key) || ''; });
  arrayFields.forEach(key => { query[key] = params.getAll(key); });
  query.categoryIds = query.categoryIds.map(Number);
  const page = Number(params.get('page'));
  query.page = Number.isSafeInteger(page) && page > 0 ? page : 1;
  query.sortBy = params.get('sortBy') || 'id';
  query.sortOrder = params.get('sortOrder') || 'desc';
  return query;
};

export const updateProductListQuery = (search, changes, resetPage = true) => {
  const params = new URLSearchParams(search);
  Object.entries(changes).forEach(([key, value]) => {
    params.delete(key);
    const values = Array.isArray(value) ? value : [value];
    values.forEach(item => {
      if (item != null && item !== '') params.append(key, String(item));
    });
  });
  if (resetPage) params.set('page', '1');
  const query = params.toString();
  return query ? `?${query}` : '';
};

/** Share exactly the same filters between the paginated list and select-all. */
export const toProductFilterParams = (query) => {
  const params = {};
  ['productId', 'quantityFrom', 'quantityTo', 'priceFrom', 'priceTo', 'discountFrom', 'discountTo'].forEach(key => {
    // Preserve invalid values so the API rejects them instead of broadening selection.
    if (query[key] !== '') params[key] = Number(query[key]);
  });
  if (query.search) params.search = query.search;
  if (query.state.length) params.state = query.state;
  if (query.categoryIds.length) params.categoryIds = query.categoryIds;
  const discountCategoryNames = query.discountCategoryNames.filter(name => name !== DISCOUNT_CATEGORY_EMPTY);
  if (discountCategoryNames.length) params.discountCategoryNames = discountCategoryNames;
  if (query.discountCategoryNames.includes(DISCOUNT_CATEGORY_EMPTY)) params.includeEmptyDiscountCategory = true;
  return params;
};
